import React from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {signinOptionsCountSelector} from 'features/signin-options/selectors';
import {deleteAllSigninOptions} from 'features/signin-options/reducers/recordsSlice';

import {ActionsControl} from './ActionsControl';

export const SigninOptionsControl = () => {
    const dispatch = useDispatch();

    const signinOptionsCount = useSelector((state) =>
        signinOptionsCountSelector(state)
    );

    return (
        <ActionsControl
            label="Sign-In Options Profile"
            resourceCount={signinOptionsCount}
            onClickHandler={() => dispatch(deleteAllSigninOptions())}
        />
    );
};
